






















import {Component, Vue} from 'vue-property-decorator';
import { sendShowLog, sendClickLog } from '@/common/js/log';
import 'github-markdown-css/github-markdown.css';
import data from './data';

@Component
export default class Doc extends Vue {
    private list = data;

    private articleComp = '';

    private mdPath = this.list[0].children[0].doc;

    // 动态加载组件
    private getArticleComp() {
        const article = this.mdPath;
        import('./docs/' + article).then(conmp => {
            console.log(conmp, 'conmp')
            this.$options.components[article] = conmp.default;
            this.articleComp = article;
            window.scrollTo(0, 0);
        });
    }

    private handleNodeClick(data) {
        sendClickLog('pdjs_doc', `doc_${data.id}`);
        if (!data.doc) {
            return;
        }
        this.mdPath = data.doc;
        this.getArticleComp();
    }



   created(): void {
        this.getArticleComp();
       sendShowLog('pdjs_doc');
    }

}
